import React, { useEffect, useState } from "react";
import Header from "../Header";
import { Userlogin } from "../Utils/general-function";
import { useNavigate } from "react-router-dom";
import Loader from "../Utils/Loader";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";

function Challan(props) {
  const [loading, setLoading] = useState(false);
  // const [Details, setDetails] = useState([
  //   {
  //     number: 1,
  //     challanNumber: "HR36010230421161155",
  //     offenseDetails: "49. Wrong parking",
  //     challanPlace: "ESZ",
  //     payment_url: "NA",
  //     image_url: "",
  //     challanDate: "21/04/2023 04:11:55 PM",
  //     state: "HR",
  //     rto: "Gurgaon",
  //     accusedName: "AJAY SETIA",
  //     accused_father_name: "VIJAY SETIA",
  //     amount: "500",
  //     challanStatus: "Cash",
  //     court_status:
  //       "Online payment service is not available for this State or RTO. Kindly Contact Gurgaon - ESZ for further process.",
  //   },
  //   {
  //     number: 2,
  //     challanNumber: "HR46416221226021155",
  //     offenseDetails: "35. Violation of road marking",
  //     challanPlace: "GCB",
  //     payment_url: "NA",
  //     image_url: "",
  //     challanDate: "10/12/2022 08:50:20 AM",
  //     state: "HR",
  //     rto: "Gurgaon",
  //     accusedName: "VIJAY KUMAR",
  //     accused_father_name: "NA",
  //     amount: "500",
  //     challanStatus: "Pending",
  //     court_status:
  //       "The challan has been sent to court sec-40 ps area on 2023-03-25. Please dispose the challan in court. httpsvcourts.gov.in",
  //   },
  // ]);
  const [searchtxt, setSearchtxt] = useState("");
  // const [Details, setDetails] = useState([
  //   {
  //     forChallan: null,
  //     typeAccused: null,
  //     nameViolator: "NARESHKUMAR",
  //     violatorFatherName: "KARSANBHAI PATEL",
  //     violatorContactNo: "9825156357",
  //     dlRcNumber: "GJ08BN1256",
  //     challanNo: "RJ4159017250227030206",
  //     State: "RJ",
  //     dateChallan: "2025-02-10 00:00:00",
  //     detailsViolation: [
  //       {
  //         offence:
  //           "Driving at excess speed (LMV)   183(1)(i) अतिरिक्त गति से ड्राइविंग (LMV)   183(1)(i) ( 183(1)(i) ) ",
  //         penalty: null,
  //       },
  //     ],
  //     investigateUnder: null,
  //     longLat: null,
  //     locationChallan: "pali road, mogra",
  //     remarkChallan: null,
  //     typeBook: null,
  //     bookNo: null,
  //     formNo: null,
  //     witness1: null,
  //     witness2: null,
  //     witness3: null,
  //     imagesChallan: null,
  //     imageVehicle: "",
  //     imageCCTV1: null,
  //     imageCCTV2: null,
  //     numberDL: null,
  //     detailsDL: null,
  //     suspendISDL: null,
  //     accNameDL: null,
  //     accAddressDL: null,
  //     accFatherNameDL: null,
  //     accAgeDL: null,
  //     accGenderDL: null,
  //     validityDL: null,
  //     issueDateDL: null,
  //     issuedByDL: null,
  //     amountChallan: 1000,
  //     status: "Paid",
  //     sourcePayment: "ONLINE",
  //     datePayment: "2025-02-28 17:21:59",
  //     IDTransaction: null,
  //     noReceipt: "RJRTE25050001521",
  //     noReceiptOffline: null,
  //     receiptOffline: null,
  //     noMobile: null,
  //     byPayment: null,
  //     acfIS: null,
  //     amountACF: null,
  //     noReceiptACF: null,
  //     nameRTO: "JODHPUR COMMISSIONERATE",
  //     impoundDocument: null,
  //     impoundVehicle: null,
  //     classVehicle: null,
  //     typeVehicle: null,
  //     uptoVehicle: null,
  //     uptoPermit: null,
  //     rcNo: "GJ08BN1256",
  //     noChassis: null,
  //     noEngine: null,
  //     noVehOwner: null,
  //     nameOwner: null,
  //     nameFatherOwner: null,
  //     addressOwner: null,
  //     idCourt: null,
  //     statusCourt: null,
  //     idCourtRelated: null,
  //     imgOrderRelease: null,
  //     dateRelease: null,
  //     noReceiptCourt: null,
  //     byAction: null,
  //     noDispatch: null,
  //     nameCourt: null,
  //     chargesUser: null,
  //     challan_search_source: "ECHALLAN",
  //     court_status_desc: "VIRTUAL COURT",
  //   },
  // ]);

  const [totalChallan, setTotalChallan] = useState(null);
  const [Details, setDetails] = useState([
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ218442250525182015",
      State: "GJ",
      dateChallan: "2025-05-25 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "8R47+93W, Ranchod Nagar Society, Arya Nagar, Rajkot, Gujarat 360003, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "UP466008250220051604",
      State: "UP",
      dateChallan: "2025-02-11 00:00:00",
      detailsViolation: [
        {
          offence:
            "Driving a motor vehicle or causes  to drive a motor vehilce to drive in contravention of speed limit, LMV (Overspeed). (DT: 30-07-2020) ( 112/183(3) ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan: "Km 169-000(RHS)",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 2000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Kanpur Nagar RTO",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ218442241207175055",
      State: "GJ",
      dateChallan: "2024-12-07 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "5-1767, Juno Morbi Rd, Bedipara, Sadguru Nagar, Rajkot, Gujarat 360003, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235542",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ206416241105085242",
      State: "GJ",
      dateChallan: "2024-11-05 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "8PVQ+92W Para pipdiya, bus stop, Jamnagar - Rajkot Hwy, Rajkot, Gujarat 360005, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAGJIBHAI G NAKUM",
      violatorFatherName: "GOPALBHAI  NAKUM",
      violatorContactNo: "8988888305",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ233472241007181710",
      State: "GJ",
      dateChallan: "2024-10-07 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "150 foot Jamnagar road crosing, Bedi, Rajkot, Gujarat 360003, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 500,
      status: "Paid",
      sourcePayment: "ON_ROAD",
      datePayment: "2024-10-07 18:17:10",
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "VIRTUAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160728240918030201",
      State: "GJ",
      dateChallan: "2024-09-18 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "Gandhigram,RAIYA TELE PHONE PTZ                                                                                , Gandhigram, RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240823054279",
      State: "GJ",
      dateChallan: "2024-08-23 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,ASHARAM_PTZ                                                                                         , B Div., RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ230800240821172608",
      State: "GJ",
      dateChallan: "2024-08-21 00:00:00",
      detailsViolation: [
        {
          offence:
            "Failure to use safety belts while driving - other than two three wheeler / વાહન હંકારતી વખતે સેફટી બેલ્ટનો ઉપયોગ ન કરે - ટુ થ્રી વ્હીલર સિવાય ( 194B ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "Golden Portico Apartment, 210, Village, Vrindavan Society, Madhapar, Rajkot, Gujarat 360006, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 500,
      status: "Paid",
      sourcePayment: "ON_ROAD",
      datePayment: "2024-08-21 17:26:08",
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "VIRTUAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160728240524041275",
      State: "GJ",
      dateChallan: "2024-05-24 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "Gandhigram,RAIYA TELE PHONE PTZ                                                                                , RAJKOT, Gandhigram",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240416034420",
      State: "GJ",
      dateChallan: "2024-04-16 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,D-MART_PTZ                                                                                          , RAJKOT, B Div.",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ215083240402192524",
      State: "GJ",
      dateChallan: "2024-04-02 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan: "8RQ5+RJG, Velnath Para, Rajkot, Gujarat 360003, India",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240203102089",
      State: "GJ",
      dateChallan: "2024-02-03 00:00:00",
      detailsViolation: [
        { offence: "RLVD SLVD/આરએલવીડી એસએલવીડી ( 177 ) ", penalty: null },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan: "Trikon_Baug,TRIKON_BAUG-TO_MALVIYA_RKC_LANE1, RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 500,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240201060878",
      State: "GJ",
      dateChallan: "2024-02-01 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,SANT_KABIR_ROAD_PTZ_1                                                                               , RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240129071156",
      State: "GJ",
      dateChallan: "2024-01-29 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,D-MART_PTZ                                                                                          , RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160720240123081777",
      State: "GJ",
      dateChallan: "2024-01-23 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,D-MART_PTZ                                                                                          , RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 1000,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
    {
      forChallan: null,
      typeAccused: null,
      nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
      violatorFatherName: "GOPALBHAI",
      violatorContactNo: "6351235570",
      dlRcNumber: "GJ03NF8988",
      challanNo: "GJ4160728240108070093",
      State: "GJ",
      dateChallan: "2024-01-08 00:00:00",
      detailsViolation: [
        {
          offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
          penalty: null,
        },
      ],
      investigateUnder: null,
      longLat: null,
      locationChallan:
        "B Div.,SANT_KABIR_ROAD_PTZ_1                                                                               , RAJKOT",
      remarkChallan: null,
      typeBook: null,
      bookNo: null,
      formNo: null,
      witness1: null,
      witness2: null,
      witness3: null,
      imagesChallan: null,
      imageVehicle: "",
      imageCCTV1: null,
      imageCCTV2: null,
      numberDL: null,
      detailsDL: null,
      suspendISDL: null,
      accNameDL: null,
      accAddressDL: null,
      accFatherNameDL: null,
      accAgeDL: null,
      accGenderDL: null,
      validityDL: null,
      issueDateDL: null,
      issuedByDL: null,
      amountChallan: 500,
      status: "Unpaid",
      sourcePayment: null,
      datePayment: null,
      IDTransaction: null,
      noReceipt: null,
      noReceiptOffline: null,
      receiptOffline: null,
      noMobile: null,
      byPayment: null,
      acfIS: null,
      amountACF: null,
      noReceiptACF: null,
      nameRTO: "Rajkot City",
      impoundDocument: null,
      impoundVehicle: null,
      classVehicle: null,
      typeVehicle: null,
      uptoVehicle: null,
      uptoPermit: null,
      rcNo: "GJ03NF8988",
      noChassis: null,
      noEngine: null,
      noVehOwner: null,
      nameOwner: null,
      nameFatherOwner: null,
      addressOwner: null,
      idCourt: null,
      statusCourt: null,
      idCourtRelated: null,
      imgOrderRelease: null,
      dateRelease: null,
      noReceiptCourt: null,
      byAction: null,
      noDispatch: null,
      nameCourt: null,
      chargesUser: null,
      challan_search_source: "ECHALLAN",
      court_status_desc: "PHYSICAL COURT",
    },
  ]);

  const navigate = useNavigate();

  const OnChange = (e) => {
    setSearchtxt(e.target.value.toUpperCase());
  };
  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
  }, []);

  const onSubmit = () => {
    setLoading(true);
    const div = document.getElementById("result");
    const btndiv = document.getElementById("btndiv");
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    div.style.display = "block";
    btndiv.style.display = "flex";

    setLoading(false);
    try {
      fetch(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/Vehiclechallan/GetVehiclechallan?Carno=" +
          searchtxt,
        header
      )
        .then((response) => response.json())
        .then((res) => {
          console.log(res);
          if (res.Success === true) {
            div.style.display = "block";
            btndiv.style.display = "flex";
            setDetails(JSON.parse(res.Data.nJsonstring));
            setLoading(false);
          } else {
          }
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const download = async () => {
    const div = document.getElementById("result");
    const options = {
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      margin: [2, 2, 5, 5],
      filename: searchtxt + ".pdf",
      image: {
        type: "jpeg",
        quality: 1.0,
      },
      html2canvas: {
        scale: 2,
        dpi: 192,
        letterRendering: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
    };
    let totalChallan = Details.reduce(
      (acc, data, i) => acc + data?.amountChallan || 0,
      0
    );
    setTotalChallan(totalChallan);
    await html2pdf().from(div).set(options).toPdf().get("pdf").save();
  };

  const rupeeFormat = (rs) =>
    rs.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}
      <div className="text-center">
        <h2 className="page-title">Check Vehicle Challan</h2>
      </div>
      <div className="page-space">
        <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="searchtxt"
            value={searchtxt}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={(e) => onSubmit()}
          >
            Submit
          </button>
        </div>
        <div
          className="justify-content-center mb-2"
          id="btndiv"
          style={{ display: "flex" }}
        >
          <button
            className="btn rc-submit mt-3"
            style={{ lineHeight: "18px" }}
            type="submit"
            onClick={(e) => download()}
          >
            Download Pdf
          </button>
          {/* <button className="cardoc-btn">
            <img
              src="assets/images/share-d.png"
              alt="share"
              style={{ width: "32px" }}
              onClick={(e) => share()}
            />
          </button> */}
        </div>
        <div id="result" style={{ display: "block" }}>
          <div className="pt-2">
            <div className="d-flex text-center flex-column">
              <span>
                <img
                  src="assets/images/logo.png"
                  style={{ maxWidth: "120px" }}
                  alt=""
                />
              </span>
              <h4 className="ch-carno">GJ03NF8988</h4>
            </div>
          </div>
          {Details.map((data, i) => (
            <div className="challan-div" key={data?.challanNumber}>
              <span>Challan No-{data?.challanNo}</span>
              <div className="ch-details">
                <div>
                  <span>Name- </span>
                  {data?.nameViolator}
                </div>
                <div>
                  <span>Father Name-</span>{" "}
                  {data?.violatorFatherName === "NA"
                    ? "NA"
                    : data.violatorFatherName}
                </div>
                <div>
                  <span>Challan Place</span> - {data?.locationChallan}
                </div>
                <div>
                  <span>RTO</span> - {data?.nameRTO}
                </div>
                <div>
                  <span>State</span> - {data?.State}
                </div>
                <div>
                  <span>Challan Date</span> -{" "}
                  {new Date(data?.dateChallan).toLocaleDateString("es-CL")}
                </div>
                <div>
                  <span>Amount</span> - {data?.amountChallan}
                </div>
                <div>
                  <span>Challan Status</span> - {data?.status}
                </div>

                <div>
                  <span>Offense Detail</span> -{" "}
                  {data?.detailsViolation[0]["offence"]}
                </div>
                <div>
                  <span>Court Status</span> - {data.court_status_desc}
                </div>

                <div>
                  <span>Receipt No </span> -{" "}
                  {data.noReceipt ? data.noReceipt : "NA"}
                </div>
                <div>
                  <span>Payment Mode </span> -{" "}
                  {data.sourcePayment ? data.sourcePayment : "NA"}
                </div>
                <div>
                  <span>Payment Date </span> -{" "}
                  {data.datePayment
                    ? new Date(data.datePayment).toLocaleDateString("es-CL")
                    : "NA"}
                </div>
              </div>

              {Details.length === i + 1 && (
                <h1 className="mt-3 text-center text-danger">
                  Total Challan : {rupeeFormat(totalChallan || 0)}
                </h1>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Challan;
